module.exports = __webpack_public_path__ + "static/media/railway-cover.5f4a4d9c.png";